const useIsSafari = () =>
	typeof window !== 'undefined' &&
	window.navigator?.userAgent?.includes('Safari');

export default useIsSafari;
